export default __webpack_public_path__ + "static/media/playWhite.6b8d7f0d.svg";